var NationalTeamStatus;
(function (NationalTeamStatus) {
    NationalTeamStatus[NationalTeamStatus["Private"] = 0] = "Private";
    NationalTeamStatus[NationalTeamStatus["Public"] = 1] = "Public";
})(NationalTeamStatus || (NationalTeamStatus = {}));
export { NationalTeamStatus, };
